const defaultTokens = {
    label: "Aurora Luxe",
    preset: "aurora",
    palette: {
        mode: "light",
        primary: "#4F46E5",
        onPrimary: "#FFFFFF",
        secondary: "#0891B2",
        onSecondary: "#F0FDFA",
        accent: "#D946EF",
        onAccent: "#FDF4FF",
        background: "#F8FAFC",
        surface: "#FFFFFF",
        surfaceMuted: "#F1F5F9",
        border: "#E2E8F0",
        text: "#0F172A",
        textMuted: "#475569",
        success: "#0F766E",
        warning: "#B45309",
        danger: "#DC2626",
        overlay: "rgba(15, 23, 42, 0.65)",
        gradientHero:
            "linear-gradient(135deg, #4F46E5 0%, #9333EA 50%, #14B8A6 100%)",
    },
    typography: {
        fontFamily:
            "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        headingFontFamily:
            "'Clash Display', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        baseFontSize: 16,
        headingScale: 1.24,
        lineHeight: 1.58,
        letterSpacing: "-0.01em",
    },
    radii: {
        xs: "6px",
        sm: "10px",
        md: "18px",
        lg: "24px",
        pill: "999px",
    },
    shadows: {
        xs: "0 1px 2px rgba(15, 23, 42, 0.08), 0 1px 1px rgba(15, 23, 42, 0.04)",
        sm: "0 12px 30px rgba(79, 70, 229, 0.08), 0 4px 10px rgba(15, 23, 42, 0.06)",
        md: "0 25px 50px rgba(15, 23, 42, 0.15), 0 15px 30px rgba(15, 23, 42, 0.08)",
        lg: "0 35px 60px rgba(15, 23, 42, 0.18), 0 25px 40px rgba(79, 70, 229, 0.08)",
    },
    transitions: {
        fast: "150ms ease",
        medium: "225ms ease",
        slow: "350ms ease",
    },
    layout: {
        contentMaxWidth: "1280px",
        sidebarWidth: "320px",
        sectionSpacing: "64px",
        gridGap: "24px",
    },
    spacing: {
        base: 4,
        scale: 1.6,
        containerPadding: "32px",
        sectionPaddingY: "96px",
    },
};

export default defaultTokens;

